export default __webpack_public_path__ + "static/media/dashboard-icon.fe6414d7.svg";